<template>
    <router-link :to="{ name: 'system_service_node', query: { type: type } }">
    <div class="node-box" :style="{backgroundImage: title === '正常节点数' ? `url(${require('../img/running.png')})` : `url(${require('../img/error.png')})`}">
        <div class="title">
            {{ title }}
        </div>
        <div class="num">
                {{ count }}
        </div>
    </div>
    </router-link>
</template>

<script>
  export default {
    name: 'NodeNumber',
    props: {
      title: String,
      count: {
        type: Number,
        default: 0
      },
      type: Number
    },
  }
</script>

<style scoped lang="less">
    .node-box {
        height: 160px;
        border-radius: 4px;
        padding: 20px 30px;
        background-image: url("../img/running.png");
        background-size: cover;
        color: #fff;

        .title {
            font-size: 16px;
        }

        .num {
            font-size: 48px;
            padding-top: 15px;

            a {
                color: #fff;
            }
        }
    }
</style>
